module.exports = __webpack_public_path__ + "static/media/helpcard_reservation.949cebd6.svg";